module.exports = __webpack_public_path__ + "img/sanjeev_sir.8a0e31b1.jpg";